import { memo } from 'react';
import { DataTableSkeleton } from '../components/DataTable';
import { ORGANIZATIONS_COLUMNS, ORGANIZATIONS_TABLE_MIN_WIDTH } from './OrganizationsTable';

export const OrganizationsTableSkeleton = memo(function OrganizationsTableSkeleton() {
  return <DataTableSkeleton columns={ORGANIZATIONS_COLUMNS} rows={5} minWidth={ORGANIZATIONS_TABLE_MIN_WIDTH} />;
});

export default OrganizationsTableSkeleton;
